import { BTStatusBadge, BTText } from "@btnet/core-components";

import { BdsIconUploadSimple } from "@buildertrend/components";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";

import { ALLOWED_BILL_UPLOAD_FILE_TYPES } from "entity/bill/BillList/BulkBillUpload/BulkBillUploadModal.api.types";

import "./InboxDropzoneBar.less";

const supportedTypesText = `Supports ${ALLOWED_BILL_UPLOAD_FILE_TYPES.map((t) => `.${t}`).join(
    ", ",
)}`;

interface IInboxDropzoneBarProps {
    onBrowse: () => void;
}

export const InboxDropzoneBar: React.FC<IInboxDropzoneBarProps> = ({ onBrowse }) => {
    return (
        <div className="InboxDropzoneBar" data-testid="inboxDropzoneBar" data-dropzone-anchor>
            <BTRow align="middle" justify="space-between" className="InboxDropzoneBar-content">
                <BTCol className="InboxDropzoneBar-guidance">
                    <BTRow align="middle" gutter={12} className="InboxDropzoneBar-guidanceRow">
                        <BTCol>
                            <BTStatusBadge
                                testid="inboxDropzoneNewBadge"
                                textOnly
                                text="New"
                                displayType="info"
                            />
                        </BTCol>
                        <BTCol className="InboxDropzoneBar-guidanceText">
                            <BTText
                                text="Drop bills & receipts anywhere on this page — AI Bill Capture will do the data entry"
                                size="distinct-sm"
                                className="InboxDropzoneBar-title"
                            />
                            <div>
                                <BTText
                                    text={supportedTypesText}
                                    size="normal-sm"
                                    className="InboxDropzoneBar-supportedTypes"
                                />
                            </div>
                        </BTCol>
                    </BTRow>
                </BTCol>
                <BTCol className="InboxDropzoneBar-actions">
                    <BTButton
                        data-testid="inboxDropzoneBarBrowse"
                        type="secondary"
                        icon={<BdsIconUploadSimple />}
                        onClick={onBrowse}
                    >
                        Browse
                    </BTButton>
                </BTCol>
            </BTRow>
        </div>
    );
};
